import {
  IPassengerDto,
  IPassengerStationLocationRequestDto,
  IPassengerStationLocationResponseDto,
  SimpleResult,
} from "../dto";
import {
  Api,
  getCompanyId,
  getRecalculateWalkingDistancePath,
} from "../helpers";
import {
  IDropdownItem,
  IGroupResult,
  IPaginatedResult,
  ISearchCriteria,
  PassengerEntity,
} from "../models";

export class PassengerApi {
  static async activePassengersDropdownItems(): Promise<
    IDropdownItem[] | undefined
  > {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/passengers/active_passengers_dropdown_items`;
    const response = await Api.get<IDropdownItem[]>(requestUrl);

    return response?.data;
  }

  static async searchPassengerStationsLocations(
    payload: IPassengerStationLocationRequestDto,
  ): Promise<SimpleResult<IPassengerStationLocationResponseDto> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/passengers/search-stations-locations`;
    const response = await Api.post<
      SimpleResult<IPassengerStationLocationResponseDto>
    >(requestUrl, payload);
    return response?.data;
  }

  static async recalculateWalkingDistance(
    passengerId: number,
  ): Promise<SimpleResult<void> | undefined> {
    const companyId = getCompanyId()!;
    const requestUrl = getRecalculateWalkingDistancePath(
      companyId,
      passengerId,
    );
    const response = await Api.post<SimpleResult<void>>(requestUrl);
    return response?.data;
  }

  static async searchPassengerByCriteria(
    payload: ISearchCriteria<PassengerEntity>,
  ): Promise<
    | SimpleResult<
        | IPassengerDto[]
        | IPaginatedResult<IPassengerDto[]>
        | IGroupResult<IPassengerDto[]>[]
      >
    | undefined
  > {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/passengers/search`;
    const response = await Api.post<
      SimpleResult<
        | IPassengerDto[]
        | IPaginatedResult<IPassengerDto[]>
        | IGroupResult<IPassengerDto[]>[]
      >
    >(requestUrl, payload);
    return response?.data;
  }

  static async searchPassengerIdsByCriteria(
    payload: ISearchCriteria<PassengerEntity>,
  ): Promise<SimpleResult<Pick<PassengerEntity, "id">[]> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/passengers/search-ids`;
    const response = await Api.post<
      SimpleResult<Pick<PassengerEntity, "id">[]>
    >(requestUrl, payload);

    return response?.data;
  }
}
